import React from 'react';
import styles from './ContactCard.module.css';

const Details = (props) => {
  return <p className={styles.info}>{props.detailInfo}</p>;
};

export default Details;
